import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { StartPageComponent } from '../pages/cms/startPage/start-page.component';
import { Observable } from 'rxjs';
import { FormChangedGuard } from './form-changed-guard/form-changed-guard';

@Injectable({
  providedIn: 'root',
})
export class StartPageFormChangedGuard
  extends FormChangedGuard
  implements CanDeactivate<StartPageComponent>
{
  canDeactivate(
    component: StartPageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.handleNavigation(
      component.hasUnsavedChanges(component.customTileSectionForms),
      nextState.url,
      () => component.resetFormChanges
    );
  }
}
